<template>
  <div class="registerBox">
    <el-header height="46px">
      <span class="text" @click="loginTo">已有账号，立即登录</span>
    </el-header>
    <div class="body">
      <div class="body-text">
        <span>欢迎注册</span>
      </div>
      <!-- 步骤条 -->
    <div class="steps">
      <el-steps :active="active" align-center >
        <el-step title="验证手机号" description="">
        </el-step>
        <el-step title="设置密码" description=""></el-step>
        <el-step title="业务类型" description=""></el-step>
        <el-step title="注册成功" description=""></el-step>
      </el-steps>
    </div>
    <br>
    <br>
    <!-- 手机号验证码 -->
    <div class="phoneBox" v-if="active=='0'">
      <!-- 手机号 -->
      <el-input
        v-model="phone"
        maxlength="11"
        placeholder="请输入手机号"
        onkeyup="value=value.replace(/[^\d]/g,'')"
      ></el-input>
      <el-input
        v-model="code"
        maxlength=""
        placeholder="请输入验证码"
        style="margin-top:20px;"
      ></el-input>
      <span
      class="codeBtn"
      v-if="isShowGetCode"
      @click="getIdentifyCode">获取验证码</span>
      <span v-else class="codeBtn cancel-pointer"
      >{{ countdown }}s后可重试</span
      >
      <el-button  type="primary" @click="phoneNext" class="bigBtn" style="width:100%;margin-top:20px;">下一步</el-button>
    </div>
    <!-- 密码 -->
    <div class="phoneBox" v-if="active=='1'">
      <!-- 密码 -->
      <el-input
        v-model="miMa.passWord"
        maxlength=""
        placeholder="请输入密码"
        show-password
      ></el-input>
      <el-input
        v-model="miMa.passWord2"
        maxlength=""
        placeholder="请再次输入密码"
        show-password
        style="margin-top:20px;"
      ></el-input>
      <el-button  type="primary" @click="passWordNext" class="bigBtn" style="width:100%;margin-top:20px;">下一步</el-button>
    </div>
    <!-- 业务类型 -->
    <div class="phoneBox" v-if="active=='2'">
      <div style="margin-left:35%;">
      <div>
        <el-radio v-model="tuoYun" label="1">托运业务</el-radio>
      </div>
      <br>
      <div>
        <el-radio v-model="tuoYun" label="2">承运业务</el-radio>
      </div>
      <br>
      <div>
        <el-radio v-model="tuoYun" label="3">车队长业务</el-radio>
      </div>
      </div>
       <!-- 协议 -->
      <span class="xieyiBigBox" v-if="tuoYun==1">
        <el-checkbox v-model="checked"></el-checkbox>
        <span style="font-size:14px;">&nbsp;&nbsp;同意<a class="xieyi"  target="_blank"   href="http://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/contract/PdfModel/hzdzc_contract_mould.pdf">&nbsp;货物运输协议</a></span>
      </span>
      <el-button  type="primary" @click="typeNext" class="bigBtn" style="width:100%;margin-top:20px;">下一步</el-button>
    </div>
    <!-- 注册成功 -->
    <div class="phoneBox" v-if="active=='3'">
      <div style="width:17%;margin:auto;">
        <div >
          <img style="width:60px;height:60px;" src="../../../assets/register/success.png" alt="">
        </div>
        </div>
        <p style="text-align:center;font-size:14px;">恭喜您，注册成功</p>
      <el-button  type="primary" @click="renZhengGo" class="bigBtn" style="width:100%;margin-top:20px;" >立即认证</el-button>
    </div>
    </div>
  </div>
</template>
<script>
import { encryption } from '@/utils/util'
// import InputGroup from '@/components/inputGroup.vue' // 引入封装的组件
// import store from '@/store's
export default {
  data () {
    return {
      active: 0,
      phone: '', // 手机号
      isShowGetCode: true,
      countdown: 60,
      checked: false,
      miMa: {
        passWord: '',
        passWord2: ''
      },
      tuoYun: '1', // 托运
      code: '',
      smsCode: '', // 判断输入的是否正确
      registerId: '', // id
      businessFlg: '' // 业务类型
    }
  },
  methods: {
    // 已有账号，立即登录
    loginTo () {
      this.$router.push({
        path: '/login'
      })
    },
    // 立即认证
    renZhengGo () {
      this.$router.push('/common/authentication')
    },
    // 验证手机
    validateMobile (mobile) {
      return /1(3|4|5|6|7|8|9)\d{9}/.test(mobile)
    },
    next () {
      if (this.active++ > 2) this.active = 0
    },
    // 点击获取验证码
    getIdentifyCode () {
      if (this.phone == '') {
        this.$message.error('请输入手机号')
      } else if (!this.validateMobile(this.phone)) {
        this.$message.error('请正确输入手机号')
      } else {
        this.countDown()
        this.isShowGetCode = false
        this.$axios({
          // headers: {
          //   'Content-Type': 'application/json;charset=UTF-8'
          //   // Authorization: 'Bearer ' + store.getUser().access_token
          // },
          method: 'post',
          url: this.global.crm + '/register/smsCheck',
          data: {
            mobile: this.phone
          }
        })
          .then(res => {
            console.log(res.data)
            this.smsCode = res.data
          })
          .catch(error => {
            this.$message.error(error.message)
          })
        // this.$axios({
        //   method: 'post',
        //   url: this.global.crm + '/register/checkUser',
        //   data: {
        //     mobile: this.phone,
        //     userSmsCode: this.code
        //   }
        // }).then(res => {

        // })
        //   .catch(error => {
        //     this.$message.error(error.message)
        //   })
      }
    },
    countDown () {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
        }
      }, 1000)
    },
    // 验证手机下一步
    phoneNext () {
      if (this.phone == '' || !this.validateMobile(this.phone)) {
        this.$message.error('请正确输入手机号')
      } else if (this.code == '') {
        this.$message.error('请输入验证码')
      } else {
        this.$axios({
        // headers: {
        //   'Content-Type': 'application/json;charset=UTF-8'
        //   // Authorization: 'Bearer ' + store.getUser().access_token
        // },
          method: 'post',
          url: this.global.crm + '/register/checkUser',
          data: {
            mobile: this.phone,
            userSmsCode: this.code
          }
        })
          .then(res => {
            console.log(res, '666')
            if (res.code == -1) {
              this.$message.error(res.message)
            } else {
              this.active++
              // if (this.active++ > 2) this.active = 0
            }
          })
          .catch(error => {
            this.$message.error(error.message)
          })
      }
    },
    // 密码下一步
    passWordNext () {
      if (this.miMa.passWord == '' || this.miMa.passWord2 == '') {
        this.$message.error('密码不能为空')
      } else if (this.miMa.passWord != this.miMa.passWord2) {
        this.$message.error('密码输入不一致')
      } else {
        this.active++
        // if (this.active++ > 2) this.active = 0
      }
    },
    // 业务类型下一步
    typeNext () {
      if (this.tuoYun == '') {
        this.$message.error('请选择业务类型')
      } else if (this.tuoYun == 1 && !this.checked) {
        this.$message.error('请勾选货物运输协议')
      } else {
        let data = encryption({
          data: this.miMa,
          key: this.global.key,
          param: ['passWord', 'passWord2']
        })
        this.$axios({
        // headers: {
        //   'Content-Type': 'application/json;charset=UTF-8'
        //   // Authorization: 'Bearer ' + store.getUser().access_token
        // },
          method: 'post',
          url: this.global.crm + '/register/registerUser',
          data: {
            mobile: this.phone,
            password: data.passWord2,
            businessFlg: this.tuoYun
          }
        })
          .then(res => {
            this.registerId = res.data.id
            this.businessFlg = res.data.businessFlg
            localStorage.setItem('registerId', this.registerId)
            localStorage.setItem('businessFlg', this.businessFlg)
            // console.log(res, '11111')
            this.active++
          })
          .catch(error => {
            this.$message.error(error.message)
          })
        // if (this.active++ > 2) this.active = 0
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/body{
  width: 100%;
  height: 100%;
  position: relative;
  // background-color:#fff ;
}
.registerBox{
  width: 100%;
  height: 100%;
  background-color:#fff;
  position: absolute;
  left: 0;
  top: 0;
  .el-header {
    background-color: #0c46a2;
    line-height: 46px;
    .text{
      float: right;
      color: #fff;
      font-size: 13px;
      cursor: pointer;
    }
  }
  .body{
    width: 100%;
    height: 100%;
    background-color:#fff ;
    // border: solid 1px;
    .body-text{
      font-size: 19px;
      text-align: center;
      padding: 40px 0 50px 0;
      color: #409EFF;
    }
    .steps{
      width: 70%;
      // padding-top:20px;
      // padding-bottom: 50px;
      margin:0 auto;
    }
    .phoneBox{
      width: 20%;
      height: 200px;
      // border: solid 1px;
      // padding-top:50px;
      margin: 0 auto;
    }
    .codeBtn{
      position: relative;
      bottom:16%;
      // left: 70%;
      right:-72%;
      font-size: 14px;
      color: #409EFF;
      cursor: pointer;
    }
    .xieyiBigBox{
      // display: block;
      position: relative;
      top: 10px;
      left: 5%;
    }
    .xieyi{
      color: #409EFF;
      cursor: pointer;
      // font-size: 14px;
    }
  }
}
  .text-color {
    color: white;
  }
  /*步骤条样式修改------------start----------*/
  /*is-finish 圆圈颜色*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__head.is-finish {
    color: #409EFF !important;
    border-color: #409EFF !important;
  }

  /*is-process 圆圈颜色*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__head.is-process {
    color: #C0C4CC;
    border-color: #C0C4CC;
  }

  /*is-wait 圆圈颜色*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__head.is-wait {
    color: #C0C4CC;
    border-color: #C0C4CC;
  }

  /*is-finish title 颜色*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__title.is-finish {
    color: #409EFF;
    // font-weight: 700;
  }
   /*is-process  title 颜色*/
  .el-steps.el-steps--horizontal[data-v-9ebad220] .el-step.is-horizontal.is-center /deep/ .el-step__title.is-process {
    // font-weight: 700;
    color:#409EFF;
  }
  /*description 颜色*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__description.is-finish {
    color: #999999;
  }
  /*is-finish 进程结束，is-process 状态颜色非加粗*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__title.is-process {
    font-weight: 700;
    color: #409EFF;
  }

  /* is-finish line连线粗细*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__head.is-finish /deep/ .el-step__line {
    position: absolute;
    border-color: inherit;
    background-color: #409EFF;
    margin-top: 2.5%;
    border: 0.5px solid;
  }

  /* is-process line连线粗细*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__head.is-process /deep/ .el-step__line {
    border-color: inherit;
    background-color: #C0C4CC;
    margin-top: 2.5%;
    border: 0.5px solid;
  }

  /* is-wait line连线粗细*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__head.is-wait /deep/ .el-step__line {
    border-color: inherit;
    background-color: #C0C4CC;
    margin-top: 2.5%;
    border: 0.5px solid;
  }

  /* 已完成 圆圈大小修改*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__head.is-finish /deep/ .el-step__icon {
    z-index: 1;
    width: 35px;
    height: 35px;
    font-size: 20px;
    border: 1px solid;
    background:#FFF;
  }

  /* 过度点 圆圈大小修改*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__head.is-process /deep/ .el-step__icon {
    z-index: 1;
    width: 35px;
    height: 35px;
    border: 1px solid;
    font-size: 20px;
    background:#FFF;
    color: #409EFF !important;
    border-color: #409EFF !important;
  }

  /* 未完成 圆圈大小修改*/
  .el-steps.el-steps--horizontal /deep/ .el-step.is-horizontal.is-center /deep/ .el-step__head.is-wait /deep/ .el-step__icon {
    z-index: 1;
    width: 35px;
    height: 35px;
    font-size: 20px;
    border: 1px solid;
    background:#FFF;
  }

  /*步骤条样式修改------------end----------*/

</style>
